import React, { useRef, useEffect, useState } from "react";
import env from "../../../env";
import errortrans from "../../../translate/error";
import tabletrans from "../../../translate/tables";
import formtrans from "../../../translate/forms";
import FaqDetails from "./FaqDetails";
import FaqImage from "./FaqImage";
import Cookies from "universal-cookie";
const cookies = new Cookies();

function FaqDetailHolder(props) {
  const url = window.location.pathname.split("/")[3];
  const direction = props.lang ? props.lang.dir : errortrans.defaultDir;
  const lang = props.lang ? props.lang.lang : errortrans.defaultLang;
  const [error, setError] = useState({ errorText: "", errorColor: "brown" });
  const token = cookies.get(env.cookieName);
  const [content, setContent] = useState("");
  const [ProductList, setProductList] = useState();
  const [sliderChange, setSliderChange] = useState("");
  const [listCat, setListCat] = useState([]);
  useEffect(() => {
    if (url === "new") return;
    var postOptions = {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ faqId: url }),
    };

    fetch(env.siteApi + "/panel/document/fetch-faq", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.error) {
            setError({ errorText: result.error, errorColor: "brown" });
            setTimeout(
              () => setError({ errorText: "", errorColor: "brown" }),
              3000,
            );
          } else {
            setError({ errorText: "سرویس پیدا شد", errorColor: "green" });
            setContent(result.filter);
            // setListCat(result.listCat || []);
            setTimeout(
              () => setError({ errorText: "", errorColor: "brown" }),
              2000,
            );
          }
        },
        (error) => {
          console.log(error);
        },
      );
  }, []);
  useEffect(() => {
    var postOptions = {
      method: "get",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(),
    };

    fetch(env.siteApi + "/panel/document/list-faq-cat", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.error) {
            setError({ errorText: result.error, errorColor: "brown" });
            setTimeout(
              () => setError({ errorText: "", errorColor: "brown" }),
              3000,
            );
          } else {
            setError({ errorText: "سرویس پیدا شد", errorColor: "green" });

            setListCat(result.filter || []);
            setTimeout(
              () => setError({ errorText: "", errorColor: "brown" }),
              2000,
            );
          }
        },
        (error) => {
          console.log(error);
        },
      );
  }, []);
  const saveSlider = () => {
    //if(newCustomer) {
    var postOptions = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token && token.token,
        userId: token && token.userId,
      },
      body: JSON.stringify({ faqId: url, ...sliderChange }),
    };
    fetch(env.siteApi + "/panel/document/update-faq", postOptions)
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.error) {
            setError({ errorText: result.error, errorColor: "brown" });
            setTimeout(
              () => setError({ errorText: "", errorColor: "brown" }),
              3000,
            );
          } else {
            setError({ errorText: result.success, errorColor: "green" });
            setTimeout(() => (window.location.href = "/faq"), 2000);
          }
        },
        (error) => {
          console.log(error);
        },
      );
  };
  console.log(sliderChange);
  return (
    <div className="new-item" style={{ direction: direction }}>
      <div className="create-product">
        <h4>ویرایش سوالات متداول</h4>
        {content || url === "new" ? (
          <div className="pages-wrapper">
            <div className="item-box">
              <FaqDetails
                direction={direction}
                lang={lang}
                content={content}
                setSliderChange={setSliderChange}
                sliderChange={sliderChange}
                token={token}
                listCat={listCat}
              />
            </div>
            <div className="create-btn-wrapper">
              <div className="save-btn" onClick={saveSlider}>
                {formtrans.saveChanges[lang]}
              </div>
              <div
                className="cancel-btn"
                onClick={() => (window.location.href = "/faq")}
              >
                {formtrans.cancel[lang]}
              </div>
            </div>
          </div>
        ) : (
          <div>{env.loader}</div>
        )}
      </div>
    </div>
  );
}
export default FaqDetailHolder;
